import apiClient from '../client';
import $U from '../urls';

export const fetchContactSubjects = () => {
  return apiClient.request('GET', $U.CONTACT_US_SUBJECTS);
};

export const sendContactForm = form => {
  return apiClient.request('POST', $U.CONTACT_US, form);
};
